"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("../../../Text"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _BottomSheet = _interopRequireDefault(require("../../../BottomSheet"));

var _constant = require("../../constant");

var _SelectItemsMobileV = _interopRequireDefault(require("./SelectItemsMobileV2.proptypes"));

var _excluded = ["items", "value", "showPicker", "onValueChange", "onClick", "onBlur", "enablePaxAgeUpdate"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SelectItemsWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectItemsMobileV2__SelectItemsWrapper",
  componentId: "sc-e4gpqt-0"
})(["position:absolute;z-index:1;width:", ";margin-top:", ";padding:0;padding-top:", ";overflow:auto;background:", ";outline:none;border:1px solid ", ";border-radius:", ";box-shadow:0px 1px 4px rgba(0,0,0,0.16);display:", ";top:", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.backgroundColor.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius.normal;
}, function (_ref7) {
  var display = _ref7.display;
  return display;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.large;
});

SelectItemsWrapper.displayName = 'SelectItems';
var hoverCss = (0, _styledComponents.css)(["&:hover{background:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyLighter;
});

var Option = _styledComponents.default.div.withConfig({
  displayName: "SelectItemsMobileV2__Option",
  componentId: "sc-e4gpqt-1"
})(["cursor:pointer;", ";background:", ";padding:", ";display:flex;justify-content:space-between;"], function (_ref10) {
  var hoverSource = _ref10.hoverSource;
  return hoverSource === _constant.HoverSource.MouseOver ? hoverCss : '';
}, function (_ref11) {
  var theme = _ref11.theme,
      isHovered = _ref11.isHovered;
  return isHovered ? theme.colors.greyLighter : 'transparent';
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(_constant.ITEM_PADDING, " ").concat(theme.space.XSmall);
});

Option.displayName = 'Option';

var getItem = function getItem(propValue, items) {
  return items.find(function (_ref13) {
    var value = _ref13.value;
    return value === propValue;
  });
};

var SelectItemsMobileV2 = function SelectItemsMobileV2(_ref14) {
  var items = _ref14.items,
      propValue = _ref14.value,
      showPicker = _ref14.showPicker,
      onValueChange = _ref14.onValueChange,
      onClick = _ref14.onClick,
      onBlur = _ref14.onBlur,
      enablePaxAgeUpdate = _ref14.enablePaxAgeUpdate,
      restProps = (0, _objectWithoutProperties2.default)(_ref14, _excluded);

  var selectItemRef = _react.default.useRef();

  var selectedItemIndex = propValue ? items.indexOf(getItem(propValue, items)) : -1;

  var _React$useState = _react.default.useState(selectedItemIndex),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      itemIndex = _React$useState2[0],
      setItemIndex = _React$useState2[1];

  var _React$useState3 = _react.default.useState(showPicker),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      showPopup = _React$useState4[0],
      setShowPopup = _React$useState4[1];

  var _React$useState5 = _react.default.useState(_constant.HoverSource.KeyBoard),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      hoverSource = _React$useState6[0],
      setHoverSource = _React$useState6[1];

  var childAgeList = items && (items === null || items === void 0 ? void 0 : items.length) && (items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.label) <= 11;
  }));
  var ageList = enablePaxAgeUpdate ? childAgeList : items;

  _react.default.useEffect(function () {
    setShowPopup(showPicker);

    if (showPicker) {
      setItemIndex(selectedItemIndex);
    }
  }, [showPicker, selectedItemIndex]);

  var handelMouseMove = function handelMouseMove(newItemIndex) {
    return function (event) {
      event.preventDefault();
      setItemIndex(newItemIndex);
      setHoverSource(_constant.HoverSource.MouseOver);
    };
  };

  var handleOptionClick = function handleOptionClick(item, index) {
    setShowPopup(false);
    setItemIndex(index);
    onValueChange(item, index);
  };

  var heightValue = document.getElementsByTagName('option').offsetHeight * items.length + 1;
  return /*#__PURE__*/_react.default.createElement(SelectItemsWrapper, (0, _extends2.default)({}, restProps, {
    display: showPopup ? 'block' : 'none' // onKeyDown={handleKeyDown}
    ,
    tabIndex: "0",
    ref: selectItemRef // onClick={onClick}
    // onBlur={onBlur}
    ,
    onClick: function onClick() {
      setShowPopup(!showPopup);
      if (showPopup) showPopup();
    }
  }), /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
    showCloseBtn: false,
    showOverlay: true,
    overlayOpacity: "0.8",
    overlayBackgroundColor: "black",
    withContainerRadius: false,
    height: heightValue,
    onClose: function onClose() {
      setShowPopup(false);
      if (showPopup) showPopup();
    }
  }, showPopup && ageList.map(function (item, index) {
    var isSelected = selectedItemIndex === index;
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item.label,
      onMouseMove: handelMouseMove(index),
      onClick: function onClick() {
        return handleOptionClick(item, index);
      },
      itemIndex: itemIndex,
      isHovered: itemIndex === index,
      hoverSource: hoverSource,
      className: "option"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: isSelected,
      color: "neutral"
    }, item.label), isSelected && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "tertiary",
      fontsize: "titleSmall"
    }));
  })));
};

SelectItemsMobileV2.propTypes = _SelectItemsMobileV.default.PropTypes;
SelectItemsMobileV2.defaultProps = _SelectItemsMobileV.default.DefaultProps;
var _default = SelectItemsMobileV2;
exports.default = _default;